module.exports = __webpack_public_path__ + "static/builderio-ee22832b7c198a76045cae9026fa84df.png";